import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-whatsapp-verification',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './whatsapp-verification.component.html',
  styleUrls: ['./whatsapp-verification.component.css']
})
export class WhatsappVerificationComponent implements AfterViewInit {

  @ViewChild('otpContainer') otpContainer!: ElementRef;

  whatsapp: string = "";
  otp: string[] = ["", "", "", "", "", ""];
  timer = 300;
  interval: any;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    // Number passed from Register Page
    const nav = this.router.getCurrentNavigation();
    this.whatsapp = nav?.extras.state?.['whatsapp'] || "";
  }

  ngOnInit() {
    if (!this.whatsapp || this.whatsapp.trim() === "") {
      this.router.navigate(['/register']);
      return;
    }
  }

  ngAfterViewInit(): void {
    const inputs: HTMLInputElement[] =
      this.otpContainer.nativeElement.querySelectorAll('input');

    inputs.forEach((input, index) => {

      // Only numbers + auto-next
      input.addEventListener('input', () => {
        input.value = input.value.replace(/[^0-9]/g, '');
        if (input.value && index < inputs.length - 1) {
          inputs[index + 1].focus();
        }
      });

      // Auto-backspace
      input.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Backspace' && !input.value && index > 0) {
          inputs[index - 1].focus();
        }
      });
    });
    this.resendOtp();
    this.startTimer();
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timer > 0) this.timer--;
      else clearInterval(this.interval);
    }, 1000);
  }

  onOtpInput(event: any, index: number) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    this.otp[index] = input.value;

    const inputs: HTMLInputElement[] =
      this.otpContainer.nativeElement.querySelectorAll('input');

    if (input.value && index < 5) {
      inputs[index + 1].focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const target = event.target as HTMLInputElement;

    const inputs: HTMLInputElement[] =
      this.otpContainer.nativeElement.querySelectorAll('input');

    if (event.key === 'Backspace' && !target.value && index > 0) {
      inputs[index - 1].focus();
    }
  }

  verifyOtp() {
    const finalOtp = this.otp.join('');

    if (finalOtp.length !== 6) {
      alert("Enter full OTP");
      return;
    }

    this.authService.verifyOtp(this.whatsapp, finalOtp).subscribe((res: any) => {
      console.log("VERIFY RESPONSE -> ", res);

      if (res.valid === true) {
        alert("OTP Verified!");
        this.router.navigate(['/pay']);
      } else {
        alert("Invalid OTP");
      }
    });

  }

  resendOtp() {

    this.authService.sendOtp(this.whatsapp).subscribe((res: any) => {
      console.log("RESEND OTP RESPONSE -> ", res);

      if (res.success === true) {
        alert("OTP sent !");

        this.otp = ["", "", "", "", "", ""];
        const inputs: HTMLInputElement[] =
          this.otpContainer.nativeElement.querySelectorAll('input');

        inputs[0].focus();
        this.startTimer();
      }
    });

  }
}
